var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getPrimevueTranslations = function (locale) {
    var _a;
    var loadedTranslations = require("primelocale/".concat(locale, ".json"));
    var translations = __assign({}, ((_a = loadedTranslations[locale]) !== null && _a !== void 0 ? _a : {}));
    if (locale === 'cs') {
        translations.dateFormat = 'dd.mm.yy';
    }
    return translations;
};
